import React from 'react'

const Rating = ({value}) => {
  if (!value) {
    return (
      <div className="text-primary">
        <i className="fas fa-star"/>
        <i className="fas fa-star"/>
        <i className="fas fa-star"/>
        <i className="fas fa-star"/>
        <i className="fas fa-star"/>
      </div>
    )
  }

  if (value >= 5) {
    return (
      <div className="text-primary">
        <i className="fas fa-star"/>
        <i className="fas fa-star"/>
        <i className="fas fa-star"/>
        <i className="fas fa-star"/>
        <i className="fas fa-star"/>
      </div>
    )
  } else if (value >= 4.5) {
    return (
      <div className="text-primary">
        <i className="fas fa-star"/>
        <i className="fas fa-star"/>
        <i className="fas fa-star"/>
        <i className="fas fa-star"/>
        <i className="fas fa-star-half-alt"/>
      </div>
    )
  } else if (value >= 4) {
    return (
      <div className="text-primary">
        <i className="fas fa-star"/>
        <i className="fas fa-star"/>
        <i className="fas fa-star"/>
        <i className="fas fa-star"/>
        <i className="far fa-star"/>
      </div>
    )
  } else if (value >= 3.5) {
    return (
      <div className="text-primary">
        <i className="fas fa-star"/>
        <i className="fas fa-star"/>
        <i className="fas fa-star"/>
        <i className="fas fa-star-half-alt"/>
        <i className="far fa-star"/>
      </div>
    )
  } else if (value >= 3) {
    return (
      <div className="text-primary">
        <i className="fas fa-star"/>
        <i className="fas fa-star"/>
        <i className="fas fa-star"/>
        <i className="far fa-star"/>
        <i className="far fa-star"/>
      </div>
    )
  } else if (value >= 2.5) {
    return (
      <div className="text-primary">
        <i className="fas fa-star"/>
        <i className="fas fa-star"/>
        <i className="fas fa-star-half-alt"/>
        <i className="far fa-star"/>
        <i className="far fa-star"/>
      </div>
    )
  } else if (value >= 2) {
    return (
      <div className="text-primary">
        <i className="fas fa-star"/>
        <i className="fas fa-star"/>
        <i className="far fa-star"/>
        <i className="far fa-star"/>
        <i className="far fa-star"/>
      </div>
    )
  } else if (value >= 1.5) {
    return (
      <div className="text-primary">
        <i className="fas fa-star"/>
        <i className="fas fa-star-half-alt"/>
        <i className="far fa-star"/>
        <i className="far fa-star"/>
        <i className="far fa-star"/>
      </div>
    )
  } else if (value >= 1) {
    return (
      <div className="text-primary">
        <i className="fas fa-star"/>
        <i className="far fa-star"/>
        <i className="far fa-star"/>
        <i className="far fa-star"/>
        <i className="far fa-star"/>
      </div>
    )
  } else if (value >= 0.5) {
    return (
      <div className="text-primary">
        <i className="fas fa-star-half-alt"/>
        <i className="far fa-star"/>
        <i className="far fa-star"/>
        <i className="far fa-star"/>
        <i className="far fa-star"/>
      </div>
    )
  } else {
    <div className="text-primary">
      <i className="fas fa-star-half-alt"/>
      <i className="far fa-star"/>
      <i className="far fa-star"/>
      <i className="far fa-star"/>
      <i className="far fa-star"/>
    </div>
  }

  return (
    <div className="text-primary">
      <i className="far fa-star"/>
      <i className="far fa-star"/>
      <i className="far fa-star"/>
      <i className="far fa-star"/>
      <i className="far fa-star"/>
    </div>
  )
}

export default Rating
